module.exports = __webpack_public_path__ + "img/vxingkuai2.prt.4da45d7e.jpg";